import React from "react";

function TranslateFrom({
  data,
  AllData,
  TranslateFromRef,
  TransFromOpen,
  transtalteFromInput,
  setTransFromOpen,
  TranslateFromstyles,
  FromSearchInput,
  setFromSearchInput,
  handleTranslateFromInput,
  errorOne,
  setNewError,
  setErrorOne,
  setErrorTwo
}) {
  // console.log(transtalteFromInput);

  if(transtalteFromInput){
    setNewError(false)
    setErrorOne(false)
    // setErrorTwo(false)
  }
  // if (transtalteToInput == "Select target language") {
  // }


  return (
    <label className="flex flex-col w-full font-opensans mb-5 cursor-pointer items-center">
      <div className="w-full">
        <span className="text-[18px] text-left font-opensans ">
          Translate from
        </span>
        <div
          className=" w-full  min-w-[300px] lg:w-[325px] font-arial group relative"
          ref={TranslateFromRef}
        >
          <div
            className="h-[50px] px-4 bg-white border-quotetext-100 rounded-xl border w-full border-solid text-[#777777] mb-1 flex items-center justify-between"
            onClick={() => setTransFromOpen(!TransFromOpen)}
          >
            <p>
              {transtalteFromInput
                ? transtalteFromInput
                : "Select source language"}
            </p>
            <span
              className={`text-quotetext-200 arrow ${
                TransFromOpen ? "rotate-[316deg]" : "rotate-[135deg]"
              }  transition-all duration-200 ease-linear  `}
            ></span>
          </div>
          <input
            placeholder="Search..."
            style={TranslateFromstyles}
            type="text"
            className="h-[50px] px-4 absolute z-50 bg-white border-quotetext-100 rounded-tl-lg rounded-tr-lg outline-none border w-full border-solid text-[#777777]  flex items-center justify-between"
            value={FromSearchInput}
            onChange={(e) => setFromSearchInput(e.target.value)}
          />
          <ul
            className="rounded-bl-lg rounded-br-lg max-h-[350px] visible absolute z-50 top-[100px] w-full  overflow-y-scroll bg-white border-quotetext-100 border-solid border"
            style={TranslateFromstyles}
          >
            {data
              ? data?.data
                  ?.filter(({ source_language }) => {
                    if (FromSearchInput === "") {
                      return source_language;
                    } else if (
                      source_language
                        .toLowerCase()
                        .includes(FromSearchInput.toLowerCase())
                    ) {
                      return source_language;
                    }
                  })
                  ?.map(({ source_language }) => (
                    <li
                      className="h-[50px] px-4 w-full text-quotetext-200 flex items-center justify-between"
                      onClick={() => handleTranslateFromInput(source_language)}
                    >
                      {source_language}
                    </li>
                  ))
              : null}
          </ul>
        </div>
        {errorOne && <span className="text-red">This field is required.</span>}{" "}
      </div>
    </label>
  );
}

export default TranslateFrom;
